import "../assets/scss/main.scss";

import { useEffect, useState } from "react";
import Modal from "react-modal";

import { getUserById } from "../data/httpClient";
import userConfig from "../data/userConfig";
import { FormDataType } from "../types";
import { CloseModalIcon } from "./CloseModalIcon";
import FormFields from "./FormFields";

interface EditUserModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  userId: string | number;
  onUpdate?: () => void;
}

export const EditUserModal = ({
  isOpen,
  onRequestClose,
  userId,
  onUpdate,
}: EditUserModalProps) => {
  const [formData, setFormData] = useState<FormDataType>(
    userConfig.createAndEditFields.reduce(
      (prev, field) => ({
        ...prev,
        [field.fieldName as keyof FormDataType]: "",
      }),
      {} as Partial<FormDataType>
    ) as FormDataType
  );

  const getData = async (userId: number) => {
    const user = await getUserById(userId);

    const updatedFormData = userConfig.createAndEditFields.reduce(
      (prev, field) => ({
        ...prev,
        [field.fieldName]: user[field.fieldName] ?? formData[field.fieldName],
        id: user.id,
        uid: user.uid,
        provider: user.provider,
      }),
      {} as FormDataType
    );

    setFormData(updatedFormData);
  };

  useEffect(() => {
    if (userId && isOpen) {
      getData(typeof userId === "string" ? parseInt(userId) : userId);
    }
  }, [userId, isOpen]);

  // to prevent user mistakes, role editing is not allowed in this modal
  const fields = userConfig.createAndEditFields.filter(
    (f) => f.fieldName !== "roleArray" && f.fieldName !== "role"
  );

  const onClose = () => {
    onRequestClose();
    if (onUpdate) {
      onUpdate();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="standardModal"
      contentLabel="Edit User"
      ariaHideApp={false}
    >
      <CloseModalIcon onRequestClose={onClose} />
      <div className="formModalContent">
        <h3 className="list_title">User Edit</h3>

        <FormFields
          fields={fields}
          form={{ method: "edit", data: formData }}
          setFormData={(_, data) => setFormData(data)}
          formMode={"edit"}
          name={userConfig.name}
          onCreateFunction={userConfig.onCreate}
          onUpdateFunction={userConfig.onUpdate}
          afterUpdateFunction={async () => {
            await getData(
              typeof userId === "string" ? parseInt(userId) : userId
            );
            onClose();
          }}
          isModal={true}
        />
      </div>
    </Modal>
  );
};
